export default "/images/vendor/flag-icon-css/flags/4x3/jo.svg?527af4b76be5bd7e890ae7bc9aac1068";